var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 17,
    viewBox: "0 0 50 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6578 0.174316C28.681 0.174316 25.8876 2.2885 25.8629 5.31155C25.8378 7.55109 27.8606 8.79985 29.3821 9.54417C30.9518 10.3051 31.4761 10.7941 31.4709 11.4748C31.4553 12.5183 30.2149 12.9937 29.0622 12.9937C27.4553 12.9937 26.5986 12.759 25.2817 12.1799L24.7596 11.9317L24.1972 15.4159C25.1374 15.8495 26.8736 16.2252 28.6786 16.2448C32.8986 16.2448 35.6444 14.1549 35.677 10.928C35.6936 9.15175 34.6199 7.80742 32.2983 6.69749C30.8968 5.97584 30.0302 5.49733 30.0431 4.76611C30.0442 4.12001 30.7703 3.42756 32.3465 3.42756C33.6629 3.4054 34.6096 3.70756 35.355 4.02582L35.7135 4.20471L36.2604 0.829529C35.4661 0.515753 34.2126 0.174405 32.6576 0.174405L32.6578 0.174316ZM20.1738 0.445859L17.6585 16.0147H21.6771L24.1938 0.445682H20.1743L20.1738 0.445859ZM14.2863 0.460965L10.3512 11.0716L9.93173 8.91558C8.95177 6.27178 6.83032 3.49855 4.35975 2.37462L7.95939 15.9998L12.2147 15.9978L18.5427 0.461082L14.2863 0.460965ZM43.4654 0.461972C42.5026 0.461972 41.781 0.736423 41.356 1.75419L35.3885 16.0198H39.6106C39.6106 16.0198 40.301 14.0996 40.4571 13.6792C40.9179 13.6792 45.0186 13.688 45.6037 13.688C45.7281 14.2309 46.0932 16.0196 46.0932 16.0196H49.8263L46.5712 0.461981L43.4654 0.461972ZM43.7494 4.65931L44.0174 6.00148C44.0174 6.00148 44.7899 9.71619 44.951 10.4942H41.6138C41.9477 9.60084 43.2152 6.14243 43.2152 6.14243C43.1905 6.18473 43.545 5.24197 43.7494 4.65931Z",
    fill: "#0023A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70177 0.452794H0.218083L0.180313 0.720702C5.22127 2.00992 8.54698 5.17584 9.93173 8.91964L8.52269 1.76414C8.28049 0.780081 7.575 0.487546 6.70177 0.452794Z",
    fill: "#FFAB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16.4252,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visa-card.c8dce44073aa7730dd884569eb798602.svg";
export { ForwardRef as ReactComponent };